/* eslint-disable */
import { useCallback } from 'react';

export const useNumber = () => {
  const toFixed = useCallback((value, digits) => {
    if (isNaN(value)) return Number.NaN.toString();
    return Number(value).toFixed(digits);
  }, []);

  const toFixedFloor = useCallback((value, digits) => {
    if (isNaN(value)) return Number.NaN.toString();
    const factor = Math.pow(10, digits);
    return (Math.floor(Number(value) * factor) / factor).toFixed(digits);
  }, []);

  const round = useCallback(
    (value, digits = 2) => {
      const result = toFixed(value, digits);
      if (isNaN(result)) return Number.NaN;
      return parseFloat(result);
    },
    [toFixed],
  );

  return { toFixed, toFixedFloor, round };
};
